export default "__VITE_ASSET__ab9f39f0__"